var changeEpiQuickNavigatorEditLink = (function () {
  
  function waitForElm(selector) {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
                observer.disconnect();
                resolve(document.querySelector(selector));
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
  }

  /* ********** Exponerade funktioner     */
  function init() {
    // Tries to find custom edit link element
    var editLinkElement = document.getElementById("custom-epi-quickNavigator-editLink");
    var editLinkUrl = editLinkElement?.getAttribute("data-url");

    // If the url is found, wait for the quick navigator edit link element to be loaded and replace the href attribute
    if (editLinkUrl) {
      waitForElm("#epi-quickNavigator>.epi-quickNavigator-editLink>a").then(elm => {
        elm.setAttribute("href", editLinkUrl);
      });
    }

    // If the custom edit link element is found, remove it
    if (editLinkElement) {
      editLinkElement.remove();
    }
  }

  return {
    init: init,
  };
})();

export default changeEpiQuickNavigatorEditLink;